module.exports = __webpack_public_path__ + "static/pic12-a3df2b54a82e5d574c70ff8c153429b5.jpg";